/**
 * External dependencies
 */

import React from "react";
import classNames from "classnames";
import { Box } from "@towersystems/towersystems-design-system";

/**
 * Style dependencies
 */
import "./styles.scss";

const FormLabel = ({ className, ...props }) => {
  return (
    <Box
      component="label"
      className={classNames(className, "form-label")}
      marginBottom="small"
      padding="medium"
      {...props}
    >
      {props.children}
    </Box>
  );
};

FormLabel.propTypes = {};

export default FormLabel;
